import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Agreement } from "@modules/agreements/types";

export const usePlanListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  planModalRef: RefObject<ModalRef>,
  agreements?: Agreement[]
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("subscription_plan_admin.fields.id"),
        width: 80,
      },
      {
        field: "display_name",
        headerName: translate("subscription_plan_admin.fields.name"),
        minWidth: 1,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "access_amount",
        headerName: translate("subscription_plan_admin.fields.access_amount"),
        minWidth: 150,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "agreement",
        headerName: translate("subscription_plan_admin.fields.agreement"),
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreements?.find(a => a.id === value)?.name}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "right",
        minWidth: 120,
        width:  1,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="end">
            <EditButton
              hideText
              onClick={() => planModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              resource="v1/subscription_plan_admin"
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, planModalRef, agreements]
  );
};
